import http from '@/util/http-common'

const endpoint = 'mqtt/dashboard'

export default {
  summary (networkId, staleAfterSeconds = 120) {
    return http.get(`${endpoint}/summary`, { params: { networkId, staleAfterSeconds } })
  },
  devices (networkId, { online, limit = 100 } = {}) {
    const params = { networkId, limit }
    if (online !== null && online !== undefined && online !== '') params.online = online
    return http.get(`${endpoint}/devices`, { params })
  },
  device (networkId, vehicleId, macAddress) {
    return http.get(`${endpoint}/devices/${encodeURIComponent(networkId)}/${encodeURIComponent(vehicleId)}/${encodeURIComponent(macAddress)}`)
  },
  async networksFromTopics () {
    const response = await http.post('mqtt/topics/list', {
      pageNumber: 1,
      pageSize: 500,
      search: '',
      isActive: true,
      sortColumn: 'topic',
      sortDirection: 'asc',
    })
    const wrapper = response.data || {}
    const source = Array.isArray(wrapper) ? wrapper : (wrapper.data || wrapper)
    const items = Array.isArray(source) ? source : (source.items || source.data || source.results || source.records || [])
    const networks = new Map()

    items.forEach(item => {
      const match = String(item.topic || '').match(/^taxi\/(\d+)\//i)
      if (match) networks.set(match[1], item.topic)
    })

    return Array.from(networks, ([value, topic]) => ({
      value,
      text: `Network ${value}`,
      topic,
    })).sort((a, b) => Number(a.value) - Number(b.value))
  },
}
